import React from 'react';
import { Container } from '../../components/ui/Container';
export function ComplaintsAndReporting() {
  return <>
      <section className="py-16 md:py-24" data-id="element-3847" data-mp="37uaasav55bez">
        <Container data-id="element-3848" data-mp="37t8xs0ukeeum">
          <div className="max-w-4xl mx-auto" data-id="element-3849" data-mp="2tw3ta5ai1o1h">
            <h1 className="font-display text-4xl md:text-6xl text-ink-900 leading-tight" data-id="element-3850" data-mp="2tvajevg8uif4">
              Complaints & Reporting Policy
            </h1>
            <p className="mt-4 text-ink-500" data-id="element-3851" data-mp="2k6ai35e9raxr">
              <strong data-id="element-3852" data-mp="2k4g12264c2yy">Last updated:</strong> February 1, 2026
            </p>

            <div className="mt-10 space-y-8 text-ink-700 leading-relaxed" data-id="element-3853" data-mp="2oxskzyzurlld">
              <p data-id="element-3854" data-mp="2a8cyiv7cu2bh">
                The <strong data-id="element-3855" data-mp="2a8w3lbbwow83">International Islamic Learning Hub (IILH)</strong>{' '}
                encourages open feedback and responsible reporting to ensure we
                maintain our high standards.
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3856" data-mp="217og7oaxhfss">
                Scope of Reporting
              </h2>
              <p data-id="element-3857" data-mp="16k7we14ma3km">
                Individuals may report issues including, but not limited to:
              </p>
              <p data-id="element-3858" data-mp="12j5wdi2vlnhl">
                • Concerns regarding the conduct or behavior of staff or
                participants.
              </p>
              <p data-id="element-3859" data-mp="1ghvsovhvfj4w">• Safeguarding and child protection issues.</p>
              <p data-id="element-3860" data-mp="1bit1adutdbfe">• Suspected misuse of funds or financial irregularities.</p>
              <p data-id="element-3861" data-mp="ntq94c2k006n">• Ethical violations or governance concerns.</p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3862" data-mp="ntzzi0rig9cv">
                How to Report
              </h2>
              <p data-id="element-3863" data-mp="xjjjxauvgb9u">
                Reports should be submitted confidentially via email to:{' '}
                <a href="mailto:complaints@iilh.org" className="text-forest-700 underline hover:text-forest-800" data-id="element-3864" data-mp="sstdrvemg4e3">
                  complaints@iilh.org
                </a>
                .
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3865" data-mp="3mfmxj2xgtd">
                Handling of Reports
              </h2>
              <p data-id="element-3866" data-mp="255i2uuluezl4">
                <strong data-id="element-3867" data-mp="254yjrakgi55i">Impartiality:</strong> All reports are reviewed
                impartially by a designated compliance officer.
              </p>
              <p data-id="element-3868" data-mp="29x031gg1kw51">
                <strong data-id="element-3869" data-mp="29ykrqpfodkuz">Confidentiality:</strong> The identity of the reporter
                and the details of the report are kept strictly confidential.
              </p>
              <p data-id="element-3870" data-mp="1h9ds1n4hip85">
                <strong data-id="element-3871" data-mp="1h9vvp4th85q3">Non-Retaliation:</strong> Retaliation against any
                individual for making a report in good faith is strictly
                prohibited.
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>;
}